import { collectionAllowed, GA_ID, publicPagePath } from './analyticsPolicy';

let loaded = false, lastPage = '';
function tag(...args) {
  if (!collectionAllowed()) return;
  if (!loaded) {
    loaded = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', GA_ID, { send_page_view: false, allow_google_signals: false, allow_ad_personalization_signals: false });
    const script = document.createElement('script'); script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script);
  }
  window.gtag(...args);
}

// Only bounded product categories go to Google. Questions, control labels,
// generated titles, visitor IDs and individual View URLs stay out of GA4.
export function analyticsEvent(name, parameters = {}) {
  if (!collectionAllowed()) return;
  const allowed = ['site_search', 'site_ask', 'view_composed', 'reading_mode', 'gallery_tour', 'exhibition_complete', 'ticket_open', 'audio_play'];
  if (!allowed.includes(name)) return;
  const safe = {};
  for (const key of ['surface', 'presentation', 'outcome']) {
    if (/^[a-z_]{1,30}$/.test(parameters[key] || '')) safe[key] = parameters[key];
  }
  if (['site_search', 'site_ask', 'view_composed'].includes(name)) {
    window.dispatchEvent(new CustomEvent('site-analytics-action', { detail: { name, parameters: safe } }));
  }
  tag('event', name, safe);
}

export function startSiteAnalytics(router) {
  const syncPreference = () => { window[`ga-disable-${GA_ID}`] = !collectionAllowed(); };
  window.addEventListener('analytics-preference', syncPreference);
  window.addEventListener('storage', syncPreference);
  function page(to) {
    window[`ga-disable-${GA_ID}`] = !collectionAllowed();
    if (!collectionAllowed() || to.fullPath === lastPage) return;
    lastPage = to.fullPath;
    const path = publicPagePath(to.path);
    tag('event', 'page_view', { page_path: path, page_location: `${location.origin}/#${path}`,
      page_title: path === '/view' ? 'View' : to.meta?.title || 'H.W.' });
  }
  router.afterEach((to, from, failure) => { if (!failure) page(to); });
  router.isReady().then(() => page(router.currentRoute.value));
}
